const env = import.meta.env;

export default env;
